


















































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth, API } from 'aws-amplify';
import { Role } from '@/lib/Role'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import {
  IUser,
} from '@/graphql/user/interfaces/user'
import { query as tenant } from '@/store/tenant'
import { mutateSnackbar } from '@/store/snackbar'

// Source: https://www.petermorlion.com/iterating-a-typescript-enum/
function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
}

async function adminApiCall(operation, path, customInit = {}) {
  const apiName = 'AdminQueries';
  const Authorization = (await Auth.currentSession()).getAccessToken().getJwtToken()
  const headers = {
        'Content-Type' : 'application/json',
        Authorization,
  }
  const init = {
    headers,
    ...customInit,
  }
  switch(operation) {
    case 'get':
      return API.get(apiName, path, init);
    case 'delete':
      return API.del(apiName, path, init);
    case 'put':
      return API.put(apiName, path, init);
    case 'post':
      return API.post(apiName, path, init);
    case 'patch':
      return API.patch(apiName, path, init);
  }
}

@Component<UsersView>({
  components: {
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('users.title')
    }
  },

  apollo: {
    tenant
  }
})
export default class UsersView extends Vue {
  users = []
  usersNextToken
  isLoading = false
  currentUserId = null
  isUserAdmin = false

  created() {
    this.getCurrentUser();
  }

  @Watch('tenant')
  fetchUsers() {
    this.listUsers(60);
  }

  async listUsers(limit){
    this.isLoading = true
    try {
      const { NextToken, Users } = await adminApiCall('get', '/listUsersInGroup', {
        queryStringParameters: {
          "groupname": this.tenant?.id,
          "limit": limit,
          "token": this.usersNextToken
        },
      })
      this.usersNextToken = NextToken;
      this.users = Users.map(i => ({
        id: i.Username,
        email: i.Attributes.find(e => e.Name === "email").Value,
        roles: i.Groups.filter(i => !i.GroupName.startsWith("tenant-"))
      }))
    } catch(err) {
      mutateSnackbar({ text: String(err), color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

  async getCurrentUser() {
    // @ts-ignore
    const { accessToken: { payload }} = await Auth.currentSession()
    this.currentUserId = payload.sub
    this.isUserAdmin = payload["cognito:groups"].includes("admin")
  }

  get roles() {
    const roles = []
    for (const value of enumKeys(Role)) {
      roles.push({
        name: value,
        value: Role[value],
      })
    }
    return roles
  }

  get newUser() {
    if (!this.roles) {
      return
    }
    const defaultRole = this.roles.find(({ name }) => name === `Author`)
    return {
      name: ``,
      email: ``,
      password: ``,
      role: (defaultRole?.value) || ``,
      tenant: ``,
      twoFactor: false,
    }
  }

  get selectRoleOptions() {
    const filteredRoles = this.roles.filter(role =>
      role.name === 'Admin' ? this.isUserAdmin : true && role.name !== 'Contributor'
    )
    const roles = filteredRoles.map(role => {
      return {
        value: role.value,
        text: this.$t(`role.${role.name}`)
      }
    })
    return roles
  }

  async addUser() {
    try {
      const { User } = await adminApiCall('post',`/createNewUser`, {
        body: {
          email: this.newUser.email,
          tenant: this.tenant.id,
          role: this.newUser.role,
          twoFactor: this.newUser.twoFactor,
        },
      })
      this.users.push({
        ...User,
        email: User.Attributes.find(e => e.Name === "email").Value,
        roles: User.Groups.filter(i => !i.GroupName.startsWith("tenant-"))
      })
      mutateSnackbar(
        { text: String(`Benutzer erfolgreich erstellt.`), color: `success` },
        this.$apollo
      )
    } catch(err) {
      mutateSnackbar({ text: String(err), color: `error` }, this.$apollo)
    }
  }

  async changeEmail(email: string, user: IUser) {
    throw new Error("TODO")
    // await this.$apollo.query({
    //   query: UserMutationUpdate,
    //   variables: {
    //     id: user.id,
    //     email
    //   }
    // })
    // this.$apollo.queries.users.refetch()
  }

  async changePassword(password: string, user: IUser) {
    try {
      await adminApiCall('put',`/user/password`, {
        body: {
          sub: user.id,
          password,
        },
      })
      mutateSnackbar(
        { text: String(`Passwort erfolgreich aktualisiert.`), color: `success` },
        this.$apollo
      )
    } catch(err) {
      mutateSnackbar({ text: String(err), color: `error` }, this.$apollo)
    }
  }

  async changeRole(newRole: string, user: IUser) {
    const { roles, id: username } = user
    const currentRole = roles[0].GroupName
    const isUnchanged = newRole == currentRole
    if (isUnchanged) return;
     try {
      await Promise.all([
        adminApiCall('post',`/addUserToGroup`, {
        body: {
          username,
          groupname: newRole,
        },
      }),
       adminApiCall('post',`/removeUserFromGroup`, {
        body: {
          username,
          groupname: currentRole,
        },
      }),
      ])
      mutateSnackbar(
        { text: String(`Benutzer erfolgreich aktualisiert.`), color: `success` },
        this.$apollo
      )
    } catch(err) {
      mutateSnackbar({ text: String(err.message), color: `error` }, this.$apollo)
    }
  }

  async deleteUser(user: IUser) {
    try {
      await adminApiCall('post',`/user/delete`, { body: { sub: user.id }})
      mutateSnackbar(
        { text: String(`Erfolgreich gelöscht`), color: `success` },
        this.$apollo
      )
      this.fetchUsers()
    } catch(err) {
      mutateSnackbar({ text: String(err), color: `error` }, this.$apollo)
    }
  }
}
